import {FullPageLoader} from '@common/ui/progress/full-page-loader';
import {Trans} from '@common/i18n/trans';
import {useForm} from 'react-hook-form';
import {CrupdateResourceLayout} from '@common/admin/crupdate-resource-layout';
import {useLender} from '@app_modules/admin/lenders/requests/use-lender';
import {Lender} from '@app_modules/lenders/lender';
import {LenderDetail} from './lender-detail';
import {
  UpdateLenderPayload,
  useUpdateLender,
} from '@app_modules/admin/lenders/requests/use-update-lender';

interface CreateLenderProps {
  callback_url: string;
}

export function LenderViewPage({callback_url}: CreateLenderProps) {
  const query = useLender();

  if (query.status !== 'success') {
    return <FullPageLoader />;
  }

  return <PageContent  lender={query.data. lender} callback_url={callback_url}/>;
}

interface PageContentProps {
   lender: Lender;
   callback_url: string;
}
function PageContent({ lender, callback_url}: PageContentProps) {
  const form = useForm<UpdateLenderPayload>({
    defaultValues: {
      ... lender,
    },
  });
  const updateLender = useUpdateLender(form, callback_url);

  return (
    <CrupdateResourceLayout
      form={form}
      onSubmit={values => {
        updateLender.mutate(values);
      }}
      title={
        <Trans message="View “:name“ lender" values={{name:  lender.name}} />
      }
      isLoading={updateLender.isPending}
    >
      <LenderDetail />
    </CrupdateResourceLayout>
  );
}
